import React from 'react';
import './styles/forside.css';
import image1 from '../images/image1.jpg';
import CTAButton from '../components/CTAButton';
import CTAButton2 from '../components/CTAButton2';
import { FaClipboardCheck, FaChartLine, FaClock, FaShieldAlt, FaCog, FaTools } from 'react-icons/fa';
import ContactForm from '../components/contactForm';
import LoneImage from '../images/Lone.jpg';
import heroVideo from '../images/Byggeriets partnermp4.mp4';
import LogoSlider from '../components/logoslider';

function Forside() {
  return (
    <>
      <div className="hero-section">
        <div className="hero-overlay">
          <div className="hero-content">
            <h1 className="forside-heading">Styrk din virksomheds konkurrenceevne</h1>
            <p className="hero-subtitle">Få styr på kvalitetssikring og digitale værktøjer i byggebranchen</p>
            <CTAButton text="Kom i gang" to="/kontakt" />
          </div>
        </div>
        <video 
          autoPlay 
          muted 
          loop 
          className="hero-image" 
          playsInline
        >
          <source src={heroVideo} type="video/mp4" />
        </video>
      </div>
      
      <LogoSlider />
      
      <section className="kvalitetssikring-section">
        <div className="kvalitetssikring-grid">
          <img src={image1} alt="Kvalitetssikring" className="kvalitetssikring-image" />
          <div className="kvalitetssikring-content">
            <span className="overline">Kvalitetssikring</span>
            <h2>Optimér din byggeproces med professionel kvalitetssikring</h2>
            <p className="intro-text">
              Kvalitetssikring er afgørende for et vellykket byggeprojekt. Vi hjælper dig med at implementere effektive processer, der sparer tid og ressourcer.
            </p>
            
            <div className="kvalitetssikring-points">
              <div className="ks-point-wrapper">
                <div className="ks-point-new">
                  <div className="ks-icon-wrapper">
                    <FaClipboardCheck className="ks-icon" />
                  </div>
                  <div className="ks-text">
                    <h4>Digital dokumentation</h4>
                    <p>Vi hjælper dig med at strukturere din kvalitetssikring i jeres eget kvalitetssikringssystem.</p>
                  </div>
                </div>
              </div>
              
              <div className="ks-point-wrapper">
                <div className="ks-point-new">
                  <div className="ks-icon-wrapper">
                    <FaChartLine className="ks-icon" />
                  </div>
                  <div className="ks-text">
                    <h4>Værdiskabelse</h4>
                    <p>Kvalitetssikring der aktivt bidrager til din virksomheds bundlinje</p>
                  </div>
                </div>
              </div>
              
              <div className="ks-point-wrapper">
                <div className="ks-point-new">
                  <div className="ks-icon-wrapper">
                    <FaClock className="ks-icon" />
                  </div>
                  <div className="ks-text">
                    <h4>Rettidig aflevering</h4>
                    <p>Sikrer at kvalitetsoplæg og dokumentation leveres til tiden</p>
                  </div>
                </div>
              </div>
              
              <div className="ks-point-wrapper">
                <div className="ks-point-new">
                  <div className="ks-icon-wrapper">
                    <FaShieldAlt className="ks-icon" />
                  </div>
                  <div className="ks-text">
                    <h4>Konfliktforebyggelse</h4>
                    <p>Solid dokumentation der beskytter dig ved eventuelle tvister</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="section-cta">
              <CTAButton text="Start din rejse" to="/kvalitetssikring" />
            </div>
          </div>
        </div>
      </section>

      <section className="about-section">
        <div className="about-grid">
          <div className="about-content">
            <span className="overline">Om Byggeriets Partner</span>
            <h2>Mød Lone Frederiksen</h2>
            <p>
              Med over 20 års erfaring i byggebranchen har jeg fulgt udviklingen på tæt hold og set, hvordan dokumentationskravene er steget markant gennem årene. Denne udvikling blev min motivation til at etablere Byggeriets Partner.
            </p>
            <p>
              Fra mit kontor nær Svebølle ved Kalundborg samarbejder jeg med byggebranchens aktører i hele Danmark. Mit fokus er at hjælpe virksomheder med indsamling og digitalisering af kvalitetssikring samt drift & vedligehold, herunder DS1140.
            </p>
            <p>
              Som din partner i dokumentation er mit mål at sikre, at kvalitetssikring og drift & vedligehold bliver et værdifuldt redskab - ikke en byrde. Gennem tæt samarbejde finder vi de løsninger, der passer bedst til netop din virksomhed.
            </p>
            <div className="about-cta">
              <CTAButton text="Lad os tage en snak" to="/kontakt" />
            </div>
          </div>
          <img src={LoneImage} alt="Lone Frederiksen" className="about-image" />
        </div>
      </section>

      <section className="drift-section">
        <div className="section-content">
          <div className="drift-header">
            <span className="overline light">Drift & Vedligehold</span>
          </div>

          <div className="drift-cards">
            <div className="drift-card">
              <div className="drift-card-icon">
                <FaCog />
              </div>
              <h3>Systematisk tilgang</h3>
              <p>Vi implementerer drift og vedligehold direkte i projekteringsfasen for at sikre langsigtet værdi.</p>
            </div>

            <div className="drift-card">
              <div className="drift-card-icon">
                <FaTools />
              </div>
              <h3>Klar kommunikation</h3>
              <p>Tydelig formidling af driftskrav og forventninger mellem alle involverede parter.</p>
            </div>

            <div className="drift-card">
              <div className="drift-card-icon">
                <FaShieldAlt />
              </div>
              <h3>Kvalitetssikring</h3>
              <p>Grundig dokumentation og opfølgning gennem hele byggeriets levetid.</p>
            </div>
          </div>

          <div className="contact-section">
            <div className="contact-content">
              <div className="contact-header">
                <span className="overline">Kontakt os</span>
                <h3>Lad os tale om jeres behov</h3>
                <p className="contact-intro">
                  Vi hjælper jer med at optimere jeres byggeprojekter gennem professionel kvalitetssikring og drift & vedligehold.
                </p>
              </div>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Forside;
